export default "__VITE_PUBLIC_ASSET__509fb6c9__"